import React from 'react';
import Button from 'react-bootstrap/Button';
import './signiteButton.css';

const SigniteButton = ({ style, children, className, variant, onClick, type = 'button' }) => {
  const classNames = `${className} ${variant === 'outline-primary' ? 'signiteOutlineButton' : ''} ${
    variant === 'primary' ? 'signitePrimaryButton' : ''
  }`;
  return (
    <Button variant={variant} className={classNames} style={style} onClick={onClick} type={type}>
      {children}
    </Button>
  );
};

export default SigniteButton;
